/*
 * Smoothly animates the open/close of the product-page info accordions
 * (Description, Book Details, Delivery & Return Policy). Native <details>
 * snaps open with no transition; this animates height + opacity both ways
 * with the Web Animations API, plus a setTimeout safety-cleanup so the panel
 * can never get stuck if an animation frame is dropped.
 */
(function () {
  var DURATION = 320; // ms
  var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initAccordion(details) {
    if (details.dataset.smoothInit) return;
    details.dataset.smoothInit = '1';

    var summary = details.querySelector('summary');
    var content = summary ? summary.nextElementSibling : null;
    if (!summary || !content) return;

    summary.addEventListener('click', function (e) {
      e.preventDefault();

      // Reduced-motion or no WAAPI support: just toggle instantly.
      if (reduceMotion || typeof content.animate !== 'function') {
        details.open = !details.open;
        return;
      }

      if (details.dataset.animating === '1') return;
      details.dataset.animating = '1';

      var closing = details.open;

      if (!closing) {
        details.open = true;
      }

      var fromH = closing ? content.scrollHeight : 0;
      var toH = closing ? 0 : content.scrollHeight;

      content.style.overflow = 'hidden';

      var anim = content.animate(
        [
          { height: fromH + 'px', opacity: closing ? 1 : 0 },
          { height: toH + 'px', opacity: closing ? 0 : 1 }
        ],
        { duration: DURATION, easing: EASING }
      );

      var done = false;
      function cleanup() {
        if (done) return;
        done = true;
        if (closing) details.open = false;
        content.style.overflow = '';
        content.style.height = '';
        details.dataset.animating = '';
      }

      anim.onfinish = cleanup;
      anim.oncancel = cleanup;
      // Safety net: timers keep firing even if a rAF/animation frame is dropped.
      window.setTimeout(cleanup, DURATION + 80);
    });
  }

  function initAll() {
    document.querySelectorAll('.product__accordion details').forEach(initAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
